import Quill from 'quill';

const CANCEL_SVG = `
<svg style="fill: #12284f;" xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 96 960 960" width="24"><path d="m256 856-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
`;

const SAVE_SVG = `
<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
          <path d="M2.8125 6.41953V14.625C2.8125 14.7742 2.87177 14.9173 2.97726 15.0228C3.08275 15.1282 3.22582 15.1875 3.375 15.1875H14.625C14.7742 15.1875 14.9173 15.1282 15.0228 15.0228C15.1282 14.9173 15.1875 14.7742 15.1875 14.625V3.375C15.1875 3.22582 15.1282 3.08275 15.0228 2.97726C14.9173 2.87177 14.7742 2.8125 14.625 2.8125H6.41953C6.34649 2.81225 6.27412 2.8264 6.20655 2.85415C6.13899 2.8819 6.07756 2.9227 6.02578 2.97422L2.97422 6.02578C2.9227 6.07756 2.8819 6.13899 2.85415 6.20655C2.8264 6.27412 2.81225 6.34649 2.8125 6.41953Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9 12.375C10.0873 12.375 10.9688 11.4936 10.9688 10.4062C10.9688 9.31894 10.0873 8.4375 9 8.4375C7.91269 8.4375 7.03125 9.31894 7.03125 10.4062C7.03125 11.4936 7.91269 12.375 9 12.375Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.75 5.625H11.25V2.8125" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
`;

const HTML_CONTAINER_STYLE = `
    position: fixed;
    top: 0px;
    padding-left: 5px;
    width: 100%;
    height: 100%;
    background: #00000073;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
`;

class HTMLEmbedHandler {
  quill: Quill;
  handler: string;
  range: any;
  fileHolder: HTMLInputElement;
  id: number;
  handlerId: string;
  options: {
    icons: {
      embed: string;
    };
  };
  y: number = 0;

  constructor(
    quill: Quill,
    options: {
      icons: {
        embed: string;
      };
    }
  ) {
    // save the quill reference
    this.quill = quill;
    this.handler = "htmlembed";
    this.range = this.quill.getSelection();
    this.id = 0;
    this.options = options;
    this.applyForToolbar();
  }

  attachmentIconHTML() {
    return `<img src="${this.options.icons.embed}" />`;
  }

  appendAttachmentIcon(toolbar) {
    const toolbarContainer = toolbar.container;
    const _elements = toolbarContainer.getElementsByClassName("ql-htmlembed");

    const style = document.createElement("style");
    style.appendChild(
      document.createTextNode("svg .file-toolbar:hover{ fill: #0065cc }")
    );

    if (_elements.length > 0) {
      let node = document.createElement("svg");
      node.innerHTML = this.attachmentIconHTML();

      const _element = _elements[0];
      if (!_element) return;

      if (_element?.children.length <= 0) {
        _element.appendChild(style);
        _elements[0].appendChild(node);
      }
    }
  }

  applyForToolbar() {
    const toolbar = this.quill.getModule("toolbar");

    const qlEditorEl = document.getElementsByClassName(
      "ql-editor"
    )[0] as HTMLDivElement;

    qlEditorEl.addEventListener("click", (e) => {
      this.y = e.offsetY;
    });

    this.appendAttachmentIcon(toolbar);
    if (toolbar) toolbar.addHandler(this.handler, this.handlerFn.bind(this));
  }

  handlerFn() {
    this.range = this.quill.getSelection();
    const container: HTMLElement = document.querySelector(
      ".ql-container.ql-snow"
    );
    const htmlContainer = this.insertHTMLEditor(container);
    container.appendChild(htmlContainer);
  }

  generateID() {
    return `QUILL_UPLOAD_HANDLER-${(this.id++, this.id)}`;
  }

  insertHTMLEditor(container: HTMLElement) {
    const html = `
      <style>
        .embedbody {
          border: 1px solid var(--border-color-primary);
          border-radius: 4px;
          padding: 10px;
          background: white;
          width: 700px;
          max-width: 80vw;
          position: static;
        }

        .embedbody .embedheader {
          background: white;
          border-radius: 4px 4px 0px 0px;
          padding: 14px;
          display: flex;
          justify-content: space-between;
        }

        .embedbody .embedheader > div {
          display: flex;
          align-items: center;
        }

        .embedbody .embedheadertext {
          font-style: normal;
          font-weight: 500;
          font-size: 14px;
          line-height: 17px;
          color: #6E7D92;
          display: flex;
          padding-right: 11px;
        }

        .embedbody textarea {
          width: 95%;
          height: 362px;
          outline: none;
          padding: 9px;
          margin: 6px 14px;
          background: #F8F9FB;
          border: 1px solid var(--border-color-primary);
          border-radius: 6px;
        }

        .embedbody button {
            padding: 8px 33px;
            border: none;
            cursor: pointer;
            margin-right: 2px;
            border-radius: 6px;
            display: flex;
            align-items: center;
            margin-right: 3px;
        }

        .embedbody .saveButton {
          background: #0F274A;
          border-radius: 6px;
          color: white;
        }

        .embedbody .saveButton span {
          padding-left: 5px;
        }

        .embedbody .cancelSvg {
          color: #10274b;
          margin-right: 5px;
          cursor: pointer;
        }

        .embedbody .cancelSvg span {
          padding-left: 5px;
        }

        .embedbody .embedfooter {
          display: flex;
          justify-content: flex-end;
          background: white;
          padding: 7px;
        }
        @media only screen and (max-width: 600px) {
          .embedbody {
            width: 97%;
          }
        }
        @media only screen and (max-width: 768px) {
          .embedbody {
            width: 97%;
          }
        }

      </style>
      <div class="embedbody">
      <div class="embedheader">
        <div>
          <span class="embedheadertext">Edit HTML</span>
        </div>
        <span class="cancelSvg">${CANCEL_SVG}</span>
      </div>
      <textarea class="embedBodyInput" autofocus></textarea>
      <div class="embedfooter">
          <button class="cancel">${CANCEL_SVG}<span>Close</span></button>
          <button class="tick saveButton">${SAVE_SVG}<span>Save</span></button>
      </div>
      </div>
      `;

    const htmlEl = document.querySelector(".htmlembed-tag");
    // check there is no open htmlContainer
    if (htmlEl) {
      container.removeChild(htmlEl);
    }
    const htmlContainer = document.createElement("div");
    htmlContainer.className = "htmlembed-tag";
    (htmlContainer as any).style = HTML_CONTAINER_STYLE;
    htmlContainer.innerHTML = html;

    // get the cancel icon and assign click event;
    htmlContainer.querySelector(".cancelSvg").addEventListener("click", () => {
      // check embed exists
      const htmlembed = document.querySelector(
        "[data-active-html-embed]"
      ) as HTMLElement;
      if (htmlembed) {
        htmlembed.dataset.embeddedHtml =
          htmlContainer.querySelector("textarea").value;
        delete htmlembed.dataset.activeHtmlEmbed;
      }
      container.removeChild(htmlContainer);
    });

    // get the buttons and assign click event
    htmlContainer.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", () => {
        if (button.className === "tick saveButton") {
          const range = this.range;
          if (range === null || range === undefined) {
            (document.querySelector(".ql-editor") as HTMLDivElement).focus();
          }

          // check embed exists
          const htmlembed = document.querySelector(
            "[data-active-html-embed]"
          ) as HTMLElement;
          if (htmlembed) {
            htmlembed.dataset.embeddedHtml =
              htmlContainer.querySelector("textarea").value;
            delete htmlembed.dataset.activeHtmlEmbed;
          } else {
            this.quill.insertEmbed(range.index, this.handler, {
              html: htmlContainer.querySelector("textarea").value,
              id: this.generateID(),
              icon: this.options.icons.embed,
            });
          }
          container.removeChild(htmlContainer);
        } else {
          // check embed exists
          const htmlembed = document.querySelector(
            "[data-active-html-embed]"
          ) as HTMLElement;
          if (htmlembed) {
            htmlembed.dataset.embeddedHtml =
              htmlContainer.querySelector("textarea").value;
            delete htmlembed.dataset.activeHtmlEmbed;
          }
          container.removeChild(htmlContainer);
        }
      });
    });

    return htmlContainer;
  }
}

export default HTMLEmbedHandler;
